import React from 'react';
import dictionary from "../../../translations/dictionary";
import {useAppContext} from "../../context/AppContext";

const Footer = () => {

    const { language } = useAppContext();
    const messages= dictionary[language];

    return (
        <div>
            <div className="regulations">
                <span>{messages['privacy.policy.text']}<a href={messages['privacy.policy.link']} target="_blank" rel="noreferrer">{messages['privacy.policy.link-text']}</a></span>
            </div>
            <div className="regulations">
                <span>{messages['footer.captcha.textStart']}<a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">{messages['footer.captcha.privacyLink']}</a>{messages['footer.captcha.and']}<a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">{messages['footer.captcha.serviceTermsLink']}</a>{messages['footer.captcha.textEnd']}</span>
            </div>
        </div>
    );
};

export default Footer;
